import type { ChatSubagentCard } from "../ui-types.ts";
import { isSubagentRunActive } from "./subagent-run-status.ts";

/** Parent-stream silence window before allowing chat.history reload. */
export const CHAT_HISTORY_DEFER_MS = 15_000;

export type ChatHistoryDeferHost = {
  chatRunId?: string | null;
  chatSending?: boolean;
  sessionBackgroundRuns?: Set<string>;
  sessionBackgroundRunIds?: string[];
  chatSubagents?: ChatSubagentCard[];
  chatSync?: { lastEventAt?: number | null };
};

export function hasActiveSubagentCards(cards: ChatSubagentCard[] | undefined): boolean {
  return (cards ?? []).some((card) => isSubagentRunActive(card.status));
}

export function shouldDeferChatHistoryReload(
  host: ChatHistoryDeferHost,
  opts?: {
    runId?: string | null;
    parentSessionActive?: boolean;
  },
): boolean {
  const parentActive =
    opts?.parentSessionActive ??
    Boolean(
      host.chatRunId?.trim() ||
      host.chatSending ||
      hasActiveSubagentCards(host.chatSubagents) ||
      (host.sessionBackgroundRuns?.size ?? 0) > 0 ||
      (host.sessionBackgroundRunIds?.length ?? 0) > 0,
    );
  const runId = typeof opts?.runId === "string" ? opts.runId.trim() : "";
  if (!parentActive) {
    return false;
  }
  if (runId.startsWith("inject-")) {
    return true;
  }
  if (host.sessionBackgroundRuns?.has(runId)) {
    return true;
  }
  // Keep parent transcript stable for the full parallel fan-out, not just
  // 15s after the last parent WS event (children may run for minutes).
  if (hasActiveSubagentCards(host.chatSubagents)) {
    return true;
  }
  const lastEventAt = host.chatSync?.lastEventAt;
  if (typeof lastEventAt !== "number") {
    return false;
  }
  return Date.now() - lastEventAt < CHAT_HISTORY_DEFER_MS;
}
